import axios from '../../../axios';
import { ICommunicationAnalytics } from '../../callsComposableAnalytics';
import { IJobCandidateInteraction } from '../../CandidateSearchService';

const url = 'wsreporting/api/internal-mis/';

export const getJobsPostedTrend = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}jobs-posted-trend`, searchFilter);

export const getJobsPostedOnJobBoards = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}jobs-posted-on-job-boards`, searchFilter);

export const getMappingsAndUploads = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}candidates-mappings-and-uploads`, searchFilter);

export const getSearchQueriesPerformed = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}search-queries-performed`, searchFilter);

export const getCareerPageAnalytics = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}career-page`, searchFilter);

export const getTasksByWorkspace = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}tasks-by-workspace`, searchFilter);

export const getEmailsByWorkspace = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}emails-by-workspace`, searchFilter);

export const getInteractionsWithSource = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}interactions-with-source`, searchFilter);

export const getCVViewsWithJobBoards = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}cv-views-with-job-boards`, searchFilter);

export const getEmailsSentWithProvider = (searchFilter: IJobCandidateInteraction) =>
  axios.post(`${url}emails-sent-with-provider`, searchFilter);

export const getCommunicationAcrossAllWorkspaces = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}communications-with-source-and-direction`, searchFilter);

export const getTotalJobsPostedByWorkspaceId = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}total-jobs-posted`, searchFilter);

export const getTotalJobsPostedOnJobBoards = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}total-jobs-posted-on-job-boards`, searchFilter);

export const getCandidatesStats = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}candidate-stats`, searchFilter);

export const getTotalAppliedCandidatesBySource = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}total-applied-candidates-by-source`, searchFilter);

export const totalInteractions = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}total-interactions`, searchFilter);

export const getTotalEmailSentByWorkspaceId = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}total-emails-sent-life-time`, searchFilter);

export const getTotalCandidatesFromTalentPool = (workspaceId: string) =>
  axios.post(`candidatesearch/api/candidate/total-candidates-by-workspaceId/${workspaceId}`);

export const getConfiguredJobboards = (workspaceId: string) =>
  axios.post(`jobsearch/api/job-board/getByWorkspaceId/${workspaceId}`);

export const getPrivateExtensionUsage = (searchFilter: ICommunicationAnalytics) =>
  axios.post(`${url}private-extension-usage`, searchFilter);
